module.exports = __webpack_public_path__ + "static/scale-model-of-billings-montana-13bc0948f642e2f9340c130b0efa9c17.png";